// import HeaderHome from "./HeaderHome";
// import Newest from "./Newest";
import Button from "@/components/Button";
import Modal from "@/components/Modal";
import SuccessIcon from "@/components/SuccessIcon";
import { MEEY_REVIEW_API_URL } from "@/constants/environment";
import { ProjectContext } from "@/context/project.context";
import { useAuth } from "@/hooks/useAuth";
import { notification } from "antd";
import axios from "axios";

import { useContext, useEffect, useState } from "react";

const ReportModal = () => {
  const { currentShowFormReport, setCurrentShowFormReport } =
    useContext(ProjectContext);
  const [contentReport, setContentReport] = useState("");
  const [loading, setLoading] = useState(false);
  const { token } = useAuth();

  useEffect(() => {
    setContentReport("");
  }, [currentShowFormReport]);
  return (
    <Modal
      open={!!currentShowFormReport}
      className="z-[4000]"
      headerClassName="!bg-white border-b border-b-grey-100 !px-4"
      header={
        <div className="flex text-blue-600 gap-2 items-center">
          <i className="mrv mrv-report text-fs-24"></i>
          <span className="text-fs-20">Báo cáo</span>
        </div>
      }
      onClose={() => setCurrentShowFormReport(null)}
      footerClassName="!border-t-0"
      footer={
        <Button
          btnType="filled"
          onClick={async () => {
            setLoading(true);
            try {
              await axios.request({
                method: "post",
                baseURL: MEEY_REVIEW_API_URL,
                headers: {
                  Authorization: `Bearer ${token}`,
                },
                url: "v1/reports/create",
                data: {
                  comment: currentShowFormReport,
                  content: contentReport,
                },
              });
              notification.success({
                message: "Cảm ơn bạn đã gửi báo cáo cho chúng tôi",
                style: {
                  width: "fit-content",
                  top: 56,

                  zIndex: 500,
                },

                icon: <SuccessIcon />,
              });
            } catch (error) {
              notification.error({
                message:
                  error.response?.data?.message ??
                  "Có lỗi xảy ra, vui lòng thử lại sau",

                style: {
                  width: "100%",
                  top: 56,

                  zIndex: 500,
                },
              });
            } finally {
              setCurrentShowFormReport(null);
              setLoading(false);
            }
          }}
          loading={loading}
          color="primary"
          disabled={!contentReport.trim().length || loading}>
          Gửi báo cáo
        </Button>
      }>
      <div className="flex flex-col sm:w-[26rem]  w-[90vw]">
        <label
          className="text-fs-14 font-normal text-grey-700 mb-4"
          htmlFor="Vui lòng nhập lý do vi phạm:">
          Vui lòng nhập lý do vi phạm:
        </label>
        <textarea
          value={contentReport}
          onChange={(e) => setContentReport(e.target.value?.slice(0, 200))}
          rows={6}
          placeholder="Nhập nội dung"
          style={{
            height: "auto",
          }}
          className="border border-grey-200 pt-2 pr-3 pb-1 pl-3 rounded-md"
        />
        <div className="text-fs-12 flex justify-end text-grey-500">
          {contentReport.trim().length} / 200
        </div>
      </div>
    </Modal>
  );
};

export default ReportModal;
